<div class="rd-widget" *ngIf="widgetData">
  <div>
    <table class="widget-large contentTable" aria-hidden="true">
      <thead>
        <tr>
          <th scope="col" colspan="2" class="widget-column-header"><widget-label [widget]="this" [fieldName]="'tenantLeaseName'" [align]="'left'"></widget-label></th>
          <th scope="col" colspan="1" class="widget-column-header"><widget-label [widget]="this" [fieldName]="'tenantRiskClass'" [align]="'left'"></widget-label></th>
          <th scope="col" colspan="1" class="widget-column-header"><widget-label [widget]="this" [fieldName]="'tenantPDRange'" [align]="'left'"></widget-label></th>
          <th scope="col" colspan="1" class="widget-column-header"><widget-label [widget]="this" [fieldName]="'tenantCovenant'" [align]="'left'"></widget-label></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let tenant of widgetData.supportTenantCovenants" class="content-row">
          <td colspan="2" class="widget-column-value text-align-left"><widget-value [align]="'left'">{{ tenant.tenantLeaseName }}</widget-value></td>
          <td colspan="1" class="widget-column-value text-align-left"><widget-value [align]="'center'">{{(  (tenant.tenantRiskClass || 0) | rdLocalizedNumber:0 )}}</widget-value></td>
          <td colspan="1" class="widget-column-value text-align-left"><widget-value [align]="'center'">{{ tenant.tenantPDRange }}</widget-value></td>
          <td colspan="1" class="widget-column-value text-align-right"><widget-value [align]="'center'">{{ tenant.tenantCovenant }}</widget-value></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
